// extracted by mini-css-extract-plugin
module.exports = {"register":"register_register__2l86G"};